import type { TrendListResponsePageAllOfThreeContentItemBasicInfoAllOf } from './trendListResponsePageAllOfThreeContentItemBasicInfoAllOf';
import type { TrendListResponsePageAllOfThreeContentItemBasicInfoAllOfTwo } from './trendListResponsePageAllOfThreeContentItemBasicInfoAllOfTwo';

export type TrendListResponsePageAllOfThreeContentItemBasicInfo = TrendListResponsePageAllOfThreeContentItemBasicInfoAllOf & TrendListResponsePageAllOfThreeContentItemBasicInfoAllOfTwo;
